// MicPicker.jsx
// ---------------------------------------------------------------------------
// Phase 4D — Recording Studio Mic Toolkit
//
// Presentational dropdown bound to useStudioRecorder()'s device list +
// selection (Fix B). Default option is "System default" (empty deviceId),
// which lets the browser pick — but the VA's explicit choice overrides Chrome's
// default and persists across sessions (the hook owns the localStorage write).
//
// Also renders the optional "Mic not working?" help link that opens the VA
// recording guide.
//
// Props:
//   devices          : Array<{ deviceId, label }>
//   selectedDeviceId : string ('' = system default)
//   onChange         : (deviceId: string) => void
//   disabled         : bool   — true while a take is in progress
//   helpHref         : string — optional URL for the "Mic not working?" link
// ---------------------------------------------------------------------------

import React from 'react';
import './voiceRecorder.css';

const MicPicker = ({
  devices = [],
  selectedDeviceId = '',
  onChange,
  disabled = false,
  helpHref,
}) => {
  return (
    <div className="aai-mic-picker">
      <label className="aai-mic-picker__label" htmlFor="aai-mic-picker-select">
        <span role="img" aria-label="microphone">🎙️</span>
        Mic
      </label>
      <select
        id="aai-mic-picker-select"
        className="aai-mic-picker__select"
        value={selectedDeviceId}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.value)}
      >
        <option value="">System default</option>
        {devices.map((d) => (
          <option key={d.deviceId || 'default'} value={d.deviceId}>
            {d.label}
          </option>
        ))}
      </select>
      {helpHref && (
        // Same-tab navigation (no target="_blank"): opens the Authorator
        // Information article in this tab so the VA can use the browser Back
        // button to return. A new tab would cold-load the article route with
        // no active-article in Redux state, landing on the wrong entry.
        <a className="aai-mic-picker__help" href={helpHref}>
          ℹ️ Mic not working?
        </a>
      )}

    </div>
  );
};

export default MicPicker;
